// extracted by mini-css-extract-plugin
module.exports = {"PageCourseLectureList":"PageCourseLectureList__PageCourseLectureList__3Obu8"};